module.exports = __webpack_public_path__ + "img/wallyin-hall.8cb85e15.png";